export const CREATE_DASHBOARD_GADGET = 'charts';
export const CURRENT_CSV_FIELDS = 'currentCsvFields';
export const CURRENT_CSV_WITH_BOM_FIELDS = 'currentCsvWithBomFields';
export const CSV_FILTER_DEFAULT_FIELDS = 'csvFilterFields';

export const CURRENT_EXCEL_FIELDS = 'currentExcelFields';
export const PRINT_LIST = 'printable';

export const PRINT_DETAILS = 'printdetails';
export const EXPORT_XML = 'xml';
export const EXPORT_RSS = 'rssIssues';
export const EXPORT_RSS_WITH_COMMENTS = 'rssComments';
export const EXPORT_WORD = 'word';
export const EXPORT_ALL_EXCEL_FIELDS = 'allExcelFields';
export const EXPORT_ALL_CSV_FIELDS = 'allCsvFields';
export const EXPORT_ALL_CSV_WITH_BOM_FIELDS = 'allCsvWithBomFields';
